<app-elevation-section [title]="languageService.LNG('Label.Addition')" [removeMargin]="allowEdit" [removePadding]="true">
  <dx-data-grid
    #datagriddx
    class="pointer"
    [dataSource]="filteredAdditions"
    [rowAlternationEnabled]="true"
    [showBorders]="true"
    [columnAutoWidth]="true"
    (onEditorPreparing)="onEditorPreparing($event)"
    (onEditingStart)="onEditingStart($event)"
    (onSaving)="onSavingMultiple($event)"
    (onInitNewRow)="onInitNewRow($event)"
    (onCellPrepared)="onCellPrepared($event)"
    (onToolbarPreparing)="onToolbarPreparing($event)"
    [height]="boxHeight">

    <dxo-editing
      mode="batch"
      [allowUpdating]="allowEdit"
      [allowAdding]="allowEdit"
      [useIcons]="true">
    </dxo-editing>

    <dxo-grouping [autoExpandAll]="selectedTimeRecord"></dxo-grouping>
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>    
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="StatusId"
      caption=" "
      cellTemplate="cellTemplateStatus"
      [headerFilter]="{ dataSource: headerFilterData }"
      [allowEditing]="false"
      [width]="25">
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'cellTemplateStatus'"></div>

    <dxi-column dataField="EmployeeName" [groupIndex]="0" [caption]="languageService.LNG('Label.Employee')" [showWhenGrouped]="false"></dxi-column>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="Date"
      [caption]="languageService.LNG('Label.Date')"
      dataType="date"
      format="dd.MM.yy"
      width="80">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="EmployeeId"
      editCellTemplate="employeeEditTemplate"
      [caption]="languageService.LNG('Label.Employee')"
      [width]="200">

      <dxi-validation-rule type="required"></dxi-validation-rule>

      <dxo-lookup
        [dataSource]="timeSalaryTimeComponent?.employees"
        valueExpr="EmployeeId"
        displayExpr="EmployeeNumberAndName">
      </dxo-lookup>
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'employeeEditTemplate'">
      <div *ngIf="timeSalaryTimeComponent">
        <span style="padding-left: 7px" *ngIf="(cellInfo.data.StatusId === 4 && !timeSalaryTimeComponent.allowEditApproved) || (cellInfo.data.StatusId === 3 && !timeSalaryTimeComponent.allowEditConfirmed) || ((cellInfo.data.CategoryId === 1 || cellInfo.data.CategoryId === 7) && cellInfo.data.StatusId === 2 && !timeSalaryTimeComponent.allowEditUnconfirmed); else edit_addition_employee_select">{{cellInfo.data.EmployeeNumberAndName}}</span>
        <ng-template #edit_addition_employee_select>
          <dx-select-box
            [dataSource]="{store: timeSalaryTimeComponent.employees, paginate: true, pageSize: 10}"
            displayExpr="EmployeeNumberAndName"
            searchExpr="EmployeeNumberAndName"
            valueExpr="EmployeeId"
            (onValueChanged)="cellInfo.setValue($event.value)"
            [searchEnabled]="true"
            [height]="35"
            [showClearButton]="true"
            [value]="cellInfo.value">
          </dx-select-box>
        </ng-template>
      </div>
    </div>

    <dxi-column *ngIf="!selectedTimeRecord"
      dataField="ProjectNumberAndName"
      editCellTemplate="projectEditTemplate"
      [setCellValue]="setProjectValue"
      [caption]="languageService.LNG('Label.Project')"
      [width]="300">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <div *dxTemplate="let cellInfo of 'projectEditTemplate'">
      <div *ngIf="timeSalaryTimeComponent">
        <span style="padding-left: 7px" *ngIf="(cellInfo.data.StatusId === 4 && !timeSalaryTimeComponent.allowEditApproved) || (cellInfo.data.StatusId === 3 && !timeSalaryTimeComponent.allowEditConfirmed) || ((cellInfo.data.CategoryId === 1 || cellInfo.data.CategoryId === 7) && cellInfo.data.StatusId === 2 && !timeSalaryTimeComponent.allowEditUnconfirmed); else edit_addition_project_select">{{cellInfo.data.ProjectNumberAndName}}</span>
        <ng-template #edit_addition_project_select>
          <dx-select-box
            [dataSource]="timeSalaryTimeComponent.projectsDataSource"
            displayExpr="ProjectDisplayName"
            searchExpr="ProjectDisplayName"
            valueExpr="ProjectId"
            (onValueChanged)="onProjectValueChanged($event, cellInfo)"
            [searchEnabled]="true"
            [height]="35"
            [showClearButton]="true"
            [placeholder]="timeSalaryTimeComponent.placeholderProjectSelectSearch"
            [value]="cellInfo.data.CarrierId"
            (onFocusIn)="timeSalaryTimeComponent.focusProject($event)">
          </dx-select-box>
        </ng-template>
      </div>
    </div>

    <dxi-column
      dataField="AdditionTypeId"
      [caption]="languageService.LNG('Label.Addition')">

      <dxi-validation-rule type="required"></dxi-validation-rule>

      <dxo-lookup
        [dataSource]="additionTypes"
        valueExpr="AdditionTypeId"
        displayExpr="Description">
      </dxo-lookup>
    </dxi-column>

    <dxi-column
      dataField="Value"
      [caption]="languageService.LNG('Label.Value')"
      dataType="number"
      [width]="75">

      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      dataField="UnitDescription"
      [caption]="languageService.LNG('Label.Unit')"
      [width]="75"
      [allowEditing]="false">
    </dxi-column>

    <dxi-column
      dataField="Comment"
      [caption]="languageService.LNG('Label.Comment')">
    </dxi-column>

  </dx-data-grid>
</app-elevation-section>
